import { render, staticRenderFns } from "./LaudoEditarSinalizadorLote.vue?vue&type=template&id=32b4142d&"
import script from "./LaudoEditarSinalizadorLote.vue?vue&type=script&lang=js&"
export * from "./LaudoEditarSinalizadorLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports